import { memo } from 'react';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { StyledListItem } from './BaseAnalysesListItem.styled';
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';

const BaseListItem = ({ id, input = '', templateName = '', status, updated_at, handleClick }) => { 
  const date = new Date(updated_at).toLocaleDateString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });

  return (
    <StyledListItem disablePadding>
      <Box sx={{ display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
        {input && <Typography noWrap>{input}</Typography>}
        {templateName && <Typography noWrap>{`Template: ${templateName}`}</Typography>}
        <Typography variant='subtitle2' noWrap>Status: {status}</Typography>
        <Typography variant='subtitle2' noWrap>{date}</Typography>
      </Box>
      <Button variant='contained' onClick={() => handleClick(id)} sx={{ mr: 1 }}>View</Button>
    </StyledListItem>
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <BaseListItem {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);